import classNames from 'classnames';
import React, {ComponentProps, ReactElement, useCallback, useMemo} from 'react';

import Row from '../../../common/Row';
import {useBreakpoint} from '../../../common/util/useBreakpoint';
import {MarketplaceServiceType} from '../../../query/graphql';
import Button from '../buttons/Button';
import GenericCard from '../GenericCard';
import MultiSelect from '../MultiSelect';

type Props = {
  allServices: MarketplaceServiceType[];
  selectedIds: string[]; // Strapi service type IDs
  onChange: (selected: string[]) => void;
  className?: string;
};

const SearchByServiceTypeBox = ({allServices, selectedIds, onChange, className}: Props): ReactElement => {
  const {isMobile} = useBreakpoint('mobile');

  const handleClear = useCallback(() => {
    onChange([]);
  }, [onChange]);

  return (
    <GenericCard border={'light'} className={classNames('p-sm flex flex-col gap-xs !overflow-visible', className)}>
      <Row className={'items-center justify-between'}>
        <span>Service or product type</span>
        <Button variant={'link'} onClick={handleClear}>
          <span className={'text-xs'}>Clear All {!!selectedIds.length && `(${selectedIds.length})`}</span>
        </Button>
      </Row>
      <SearchByServiceTypeBox.Dropdown
        allServices={allServices}
        selectedIds={selectedIds}
        onChange={onChange}
        noSelectionLabel={'Select service types'}
        asModal={isMobile}
      />
    </GenericCard>
  );
};

SearchByServiceTypeBox.Dropdown = function Dropdown({
  allServices,
  selectedIds,
  onChange,
  className,
  noSelectionLabel,
  asModal,
  withClearAll,
}: Props & Pick<ComponentProps<typeof MultiSelect>, 'noSelectionLabel' | 'asModal' | 'withClearAll'>) {
  const options = useMemo(() => allServices.map(service => ({label: service.name, value: service.id})), [allServices]);

  return (
    <MultiSelect
      options={options}
      selectedValues={selectedIds}
      onChange={onChange}
      noSelectionLabel={noSelectionLabel}
      className={className}
      asModal={asModal}
      withClearAll={withClearAll}
      heading={asModal ? 'Select service types' : undefined}
    />
  );
};

export default SearchByServiceTypeBox;
